import { useState } from 'react';
import { Outlet, ScrollRestoration, useMatches } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Sheet, SheetContent, SheetDescription, SheetTitle } from '@/components/ui/sheet';
import { Sidebar } from './sidebar';
import { Topbar } from './topbar';
import { QuickServiceProvider } from '@/components/orders/quick-service-dialog';

/** Layout administrativo: sidebar fixa no desktop e menu lateral (drawer) no celular. */
export function AppLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  // Rotas com `handle: { fullWidth: true }` usam a largura toda da tela (ex.: Bancada).
  const fullWidth = useMatches().some((m) => (m.handle as { fullWidth?: boolean } | undefined)?.fullWidth);
  return (
    <QuickServiceProvider>
      <div className="min-h-dvh">
        <a
          href="#conteudo"
          className="sr-only focus:not-sr-only focus:fixed focus:left-2 focus:top-2 focus:z-50 focus:rounded focus:bg-white focus:px-3 focus:py-2"
        >
          Pular para o conteúdo
        </a>
        <aside className="no-print fixed inset-y-0 left-0 z-40 hidden w-[238px] lg:block">
          <Sidebar />
        </aside>
        <Sheet open={menuOpen} onOpenChange={setMenuOpen}>
          <SheetContent side="left" className="w-[260px] border-0 p-0">
            <SheetTitle>Menu</SheetTitle>
            <SheetDescription>Navegação principal</SheetDescription>
            <Sidebar onNavigate={() => setMenuOpen(false)} />
          </SheetContent>
        </Sheet>
        <div className="lg:pl-[238px]">
          <Topbar onMenu={() => setMenuOpen(true)} />
          <main id="conteudo" className={cn('mx-auto px-4 py-6 sm:px-8 sm:py-8', !fullWidth && 'max-w-[1440px]')}>
            <Outlet />
          </main>
        </div>
        <ScrollRestoration />
      </div>
    </QuickServiceProvider>
  );
}
